import axios from 'axios';
import { SERVER_URL } from './constants.service';

export function getProjects() {
  let filter = {
    include: {
      relation: 'mailingOrders',
      scope: {
        where: {
          status: 'QUEUED'
        }
      }
    }
  }
  return axios.get(`${SERVER_URL}/api/projects?filter=${JSON.stringify(filter)}`)
    .then(({ data }) => data);
}

export function createProject(projectData) {
  return axios.post(`${SERVER_URL}/api/projects`, projectData)
    .then(({ data }) => data);
}

export function updateProject(id, newData) {
  return axios.patch(`${SERVER_URL}/api/projects/${id}`, newData)
    .then(({ data }) => data);
}

export function deleteProject(id) {
  return axios.delete(`${SERVER_URL}/api/projects/${id}`)
    .then(({ data }) => data);
}

export default { createProject, getProjects, updateProject, deleteProject };



// WEBPACK FOOTER //
// ./src/modules/services/projects.service.js